import { render, staticRenderFns } from "./reporte-corresponsalia.vue?vue&type=template&id=690b5156&scoped=true&"
import script from "./reporte-corresponsalia.vue?vue&type=script&lang=js&"
export * from "./reporte-corresponsalia.vue?vue&type=script&lang=js&"
import style0 from "./reporte-corresponsalia.vue?vue&type=style&index=0&id=690b5156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690b5156",
  null
  
)

export default component.exports